module.exports = __webpack_public_path__ + "static/media/gym3.bb0ebd6c.jpg";